export default {
  ResreportsAnalytics: "Reports & Analytics",
  RestotalPurchase: "Total Purchase",
  RestotalOrders: "Total Orders",
  ResitemsReceived: "Items Received",
  RespendingGRN: "Pending GRN",
  RestopSuppliers: "Top Suppliers",
  Ressupplier: "Supplier",
  Resorders: "Orders",
  Resamount: "Amount",
  ResnoData: "No data",
  Resreports: "Reports",
  ResselectReportModule: "Select a report module",
  RespurchaseReport: "Purchase Report",
  RespurchaseReportDesc: "Orders placed to suppliers",
  ResgrnReport: "GRN Report",
  ResgrnReportDesc: "Goods received details",
  ResinvoiceReport: "Invoice Report",
  ResinvoiceReportDesc: "Supplier invoices",
  RessupplierPerformance: "Supplier Performance",
  RessupplierPerformanceDesc: "Supplier analytics",
  ResbackToReports: "Back to Reports",

//GRNReport
   resloading_grn_report: "Loading GRN report...",
  resgrn_report: "GRN Report",
  restotal_grns: "Total GRNs",
  restotal_received: "Total Received",
  ressearch_grn_order: "Search GRN / Order ID...",
  resall_status: "All Status",
  resgrn_id: "GRN ID",
  resreceived_qty: "Received Qty",
  resno_data_found: "No data found",
  resprev: "Prev",
  resnext: "Next",
  respage: "Page",
  resof: "of",
  status_confirmed: "Confirmed",
status_draft: "Draft",

// Supplier Report
  resloading_supplier_report: "Loading supplier report...",
  ressupplier_performance: "Supplier Performance",
  restotal_suppliers: "Total Suppliers",
  resdelivered_orders: "Delivered Orders",
  ressuccess_rate: "Success Rate",
  ressupplier: "Supplier",
  resorders: "Orders",
  resdelivered: "Delivered",
  respending: "Pending",
  restotal_spend: "Total Spend",
  ressuccess_percent: "Success %",
  resgrn_dashboard_subtitle: "Enterprise GRN Dashboard",

restotal_grns: "Total GRNs",
restotal_received: "Total Received",

resdraft: "Draft",

ressearch_grn: "Search GRN / Order / Supplier",

reslatest: "Latest",
resoldest: "Oldest",
reshighest_qty: "Highest Qty",

resgrn_details: "GRN Details",
// Invoice Report
resloading_invoice_report: "Loading invoice report...",
resinvoice_report: "Invoice Report",
resinvoice_dashboard_subtitle: "Finance & Invoice Analytics",

resdownloading: "Downloading...",

restotal_invoices: "Total Invoices",
restotal_amount: "Total Amount",
restax_amount: "Tax Amount",

ressearch_invoice: "Search Invoice / Supplier",

resunpaid: "Unpaid",

reshighest_amount: "Highest Amount",
resclear: "Clear",

resinvoice: "Invoice",

resinvoice_details: "Invoice Details",
resinvoice_no: "Invoice No",
ressearch_supplier: "Search Supplier",
resdownload_excel: "Excel",
resdownload_pdf: "PDF",


};